import { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "./pojasevi.css";
import LoaderPojas from "../components/LoaderPojas";

emailjs.init({ publicKey: "KML-P95O0jZPSRfqn" });

export default function Pojasevi() {
  const [pojasevi, setPojasevi] = useState([]);
  const [tipovi, setTipovi] = useState([]);
  const [aktivniTip, setAktivniTip] = useState(null);
  const [odabraniPojas, setOdabraniPojas] = useState("");
  const [odabranaSlika, setOdabranaSlika] = useState("");

  const [tipPojasa, setTipPojasa] = useState("");

  const [markaAuta, setMarkaAuta] = useState("");
  const [modelAuta, setModelAuta] = useState("");
  const [brojVrata, setBrojVrata] = useState("");
  const [brojSjedala, setBrojSjedala] = useState("");
  const [kojiPojasevi, setKojiPojasevi] = useState("");

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  useEffect(() => {
    fetch("https://carboncro.hr/wp-json/wp/v2/tip_pojasa")
      .then((res) => res.json())
      .then((data) => {
        setTipovi(data);
        if (data.length > 0) {
          setAktivniTip(data[0].id);
          setTipPojasa(data[0].name);
        }
      })
      .catch((err) => console.error("Greška pri dohvatu tipova:", err));

    fetch("https://carboncro.hr/wp-json/wp/v2/pojas?per_page=100&acf_format=standard")
      .then((res) => res.json())
      .then(async (data) => {
        const parsed = await Promise.all(
          data.map(async (item) => {
            let slika = "";
            if (item.featured_media) {
              const mediaRes = await fetch(
                `https://carboncro.hr/wp-json/wp/v2/media/${item.featured_media}`
              );
              const mediaData = await mediaRes.json();
              slika = mediaData.source_url || "";
            }
            return {
              id: item.id,
              naziv: item.acf?.naziv || item.title.rendered,
              slika,
              tip_pojasa: item.tip_pojasa,
            };
          })
        );
        setPojasevi(parsed);
      })
      .catch((err) => console.error("Greška pri dohvatu pojaseva:", err));
  }, []);

  const filtrirani = pojasevi.filter((p) => p.tip_pojasa?.includes(aktivniTip));

  // Dozvoljava samo znamenke i po jedan "+" na početku (za pozivni broj, npr. +385...)
  const handlePhoneChange = (e) => {
    let value = e.target.value;

    const imaPlus = value.startsWith("+");
    let samoZnamenke = value.replace(/\D/g, ""); // makni sve što nije znamenka
    samoZnamenke = samoZnamenke.slice(0, 15); // razuman max broj znamenki

    const noviBroj = (imaPlus ? "+" : "") + samoZnamenke;

    setPhone(noviBroj);

    if (phoneError) setPhoneError("");
  };

  // Provjera ispravnosti broja: 8–15 znamenki, opcionalno s "+" na početku
  const isPhoneValid = (value) => /^\+?\d{8,15}$/.test(value);

  const handlePhoneBlur = () => {
    if (phone && !isPhoneValid(phone)) {
      setPhoneError("Unesi ispravan broj telefona (npr. 0912345678 ili +385912345678).");
    }
  };

  // Zajednički tekst upita — koristi se za email
  const sastaviDetalje = () => `Tip pojasa: ${tipPojasa || "—"}
Odabrani pojas: ${odabraniPojas || "—"}
Zamjena: ${kojiPojasevi || "—"}
Marka auta: ${markaAuta || "—"}
Model auta: ${modelAuta || "—"}
Broj vrata: ${brojVrata || "—"}
Broj sjedala: ${brojSjedala || "—"}
Telefon: ${phone || "—"}
Napomena: ${note || "—"}`;

  const resetForme = () => {
    setOdabraniPojas("");
    setOdabranaSlika("");
    setTipPojasa("");
    setMarkaAuta("");
    setModelAuta("");
    setBrojVrata("");
    setBrojSjedala("");
    setKojiPojasevi("");
    setName("");
    setEmail("");
    setPhone("");
    setPhoneError("");
    setNote("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isPhoneValid(phone)) {
      setPhoneError("Unesi ispravan broj telefona (npr. 0912345678 ili +385912345678).");
      return;
    }

    const details = sastaviDetalje();

    const templateParams = {
      name,
      email,
      phone,
      subject: "Upit — Ugradnja pojaseva",
      details,
    };

    try {
      await emailjs.send("service_e1fywjb", "template_ypv0dyy", templateParams);

      alert("Upit uspješno poslan!");

      resetForme();
    } catch (error) {
      console.error("Greška:", error);
      alert("Greška pri slanju.");
    }
  };

  return (
    <div className="volan-container">
      <h1>Ugradnja pojaseva</h1>

      <div className="tip-tabovi">
        {tipovi.map((tip) => (
          <button
            key={tip.id}
            onClick={() => {
              setAktivniTip(tip.id);
              setTipPojasa(tip.name);
              setOdabraniPojas("");
              setOdabranaSlika("");
            }}
            className={aktivniTip === tip.id ? "active" : ""}
          >
            {tip.name}
          </button>
        ))}
      </div>

      <h2>Odaberi pojas</h2>
      {pojasevi.length === 0 ? (
        <LoaderPojas />
      ) : (
        <div className="material-grid">
          {filtrirani.map((p) => (
            <div
              key={p.id}
              onClick={() => {
                setOdabraniPojas(p.naziv);
                setOdabranaSlika(p.slika || "");
              }}
              className={odabraniPojas === p.naziv ? "active" : ""}
            >
              {p.slika && <img src={p.slika} alt={p.naziv} />}
              <p>{p.naziv}</p>
            </div>
          ))}
        </div>
      )}

      {odabraniPojas && (
        <div className="odabran-pojas-preview">
          {odabranaSlika && <img src={odabranaSlika} alt={odabraniPojas} />}
          <div className="odabran-pojas-info">
            <p className="odabran-label">Odabrano</p>
            <p className="odabran-naziv">{odabraniPojas}</p>
            <p className="odabran-tip">{tipPojasa}</p>
          </div>
        </div>
      )}

      <h2>Informacije o vozilu</h2>
      <input type="text" placeholder="Marka auta npr. BMW, Audi, Toyota..." value={markaAuta} onChange={(e) => setMarkaAuta(e.target.value)} />
      <input type="text" placeholder="Model auta npr. M3, RS4, Corolla..." value={modelAuta} onChange={(e) => setModelAuta(e.target.value)} />

      <div className="select-group">
        <select value={brojVrata} onChange={(e) => setBrojVrata(e.target.value)}>
          <option value="">Broj vrata</option>
          <option value="2">2 vrata</option>
          <option value="3">3 vrata</option>
          <option value="4">4 vrata</option>
          <option value="5">5 vrata</option>
        </select>
      </div>

      <div className="select-group">
        <select value={brojSjedala} onChange={(e) => setBrojSjedala(e.target.value)}>
          <option value="">Broj sjedala</option>
          <option value="2">2 sjedala</option>
          <option value="4">4 sjedala</option>
          <option value="5">5 sjedala</option>
          <option value="7">7 sjedala</option>
        </select>
      </div>

      <div className="radio-group">
        <h3>Koji pojasevi se mijenjaju?</h3>
        <label>
          <input type="radio" name="kojiPojasevi" value="Samo prednje" checked={kojiPojasevi === "Samo prednje"} onChange={(e) => setKojiPojasevi(e.target.value)} />
          Samo prednje
        </label>
        <label>
          <input type="radio" name="kojiPojasevi" value="Samo zadnje" checked={kojiPojasevi === "Samo zadnje"} onChange={(e) => setKojiPojasevi(e.target.value)} />
          Samo zadnje
        </label>
        <label>
          <input type="radio" name="kojiPojasevi" value="Kompletan auto" checked={kojiPojasevi === "Kompletan auto"} onChange={(e) => setKojiPojasevi(e.target.value)} />
          Kompletan auto
        </label>
      </div>

      <div className="summary">
        <h3>Tvoj odabir:</h3>
        <p>Tip: {tipPojasa || "—"}</p>
        <p>Pojas: {odabraniPojas || "—"}</p>
        <p>Marka: {markaAuta || "—"}</p>
        <p>Model: {modelAuta || "—"}</p>
        <p>Vrata: {brojVrata ? `${brojVrata} vrata` : "—"}</p>
        <p>Sjedala: {brojSjedala ? `${brojSjedala} sjedala` : "—"}</p>
        <p>Zamjena: {kojiPojasevi || "—"}</p>
        <p>Telefon: {phone || "—"}</p>
      </div>

      <h2>Kontakt</h2>
      <form onSubmit={handleSubmit} className="form">
        <input type="text" placeholder="Ime i prezime" value={name} onChange={(e) => setName(e.target.value)} required />
        <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />

        <input
          type="text"
          inputMode="numeric"
          placeholder="Broj telefona (npr. 0912345678)"
          value={phone}
          onChange={handlePhoneChange}
          onBlur={handlePhoneBlur}
          pattern="^\+?\d{8,15}$"
          title="Unesi samo brojeve, po potrebi s + na početku (8-15 znamenki)"
          required
        />
        {phoneError && <p className="field-error">{phoneError}</p>}

        <textarea placeholder="Dodatne želje..." value={note} onChange={(e) => setNote(e.target.value)} />

        <div className="form-actions">
          <button type="submit" className="btn">Pošalji upit</button>
        </div>
      </form>
    </div>
  );
}